export const bytesToBase64=(bytes)=>{
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte),
  ).join('');
  return window.btoa(binString);
};

export const addCustomCheckboxClass =(tempContainer)=>{
  const checkBoxs = tempContainer.querySelectorAll(
    'input[type="checkbox"].form-check-input'
  );
  
  checkBoxs.forEach(cb => {
    if (cb.checked) {
      cb.removeAttribute('checked');
      cb.checked = false;
      cb.classList.add('bootstrap-checked');
    }
  });
};